import { inlineMediaQueryMixin, token, StyledAnchor, StyledButton, StyledTextButton, hoverMediaQueryMixin } from "@zillow/constellation";
import { css } from "styled-components";
import Picture from "../../components/Picture/Picture.esm.js";
const widthMap = {
  xs: "320px",
  sm: "480px",
  md: "768px",
  lg: "1024px",
  xl: "1280px",
  full: "1920px"
};
const GROUP_WIDTH_MAP = widthMap;
const heightMap = {
  none: "auto",
  short: "300px",
  tall: "500px",
  fluid: "100vh"
};
const ATTRIBUTES = ["background-color", "font-color", "min-height", "max-width"];
const groupCSS = (props) => {
  const styles = [];
  let usePixelMinHeight = false;
  Object.keys(props).forEach((prop) => {
    const attr = prop.replace(/[A-Z]/g, (char) => `-${char.toLowerCase()}`);
    if (ATTRIBUTES.indexOf(attr) >= 0) {
      styles.push(inlineMediaQueryMixin(prop, (mediaProps) => {
        const value = mediaProps[prop];
        const linkColor = value === "textWhite" ? value : "link";
        const linkHoverColor = value === "textWhite" ? value : "linkHover";
        if (attr === "font-color") {
          return [token(`colors.${value}`, (color) => {
            if (color) {
              return css(["color:", ";"], color);
            }
            return "";
          }), css(["", ",a:not(", ",", "){color:", ";&:not(:active){", "}}"], StyledAnchor, StyledButton, StyledTextButton, token(`colors.${linkColor}`), hoverMediaQueryMixin(css(["color:", ";"], token(`colors.${linkHoverColor}`))))];
        }
        if (attr === "background-color") {
          return token(`colors.${value}`, (color) => {
            if (color) {
              return `background-color: ${color};`;
            }
            return "";
          });
        }
        if (attr === "max-width") {
          return `max-width: ${widthMap[value]};`;
        }
        if (attr === "min-height") {
          if (value === "pixel") {
            usePixelMinHeight = true;
            return "";
          }
          return `min-height: ${heightMap[value]};`;
        }
        return `${attr}: ${value};`;
      })(props));
    }
  });
  if (usePixelMinHeight) {
    if ("minHeightPixel" in props) {
      styles.push(inlineMediaQueryMixin("minHeightPixel", (mediaProps) => {
        return `min-height: ${mediaProps.minHeightPixel}px;`;
      })(props));
    }
  }
  return styles;
};
const GroupMixin = (props) => [groupCSS(props), `
        position: relative;
        margin-left: auto;
        margin-right: auto;
        width: 100%;
        > *:not(${Picture}) {
            position:relative;
        }
    `];
export {
  GROUP_WIDTH_MAP,
  GroupMixin
};
